import StopRecordingModal from "./stop-recording-modal";

export default StopRecordingModal